import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CustomImage from "./ReUse/Components/Image";
import { Rating } from "react-simple-star-rating";

function Slidecompocard({currentIndex,...propsData}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    id,
    product_id,
    seller_id,
    product_name,
    category_id,
    category_name,
    sub_category_id,
    sub_category_name,
    slug,
    thumbnail,
    unit_price,
    rating,
    categories,
  } = propsData ?? {};
  return (
    <>
      <div>
      <Link
					to={`/product-detail/${slug}`}
					state={{
						product_id: slug,
						currentIndex: currentIndex,
					}}
				>
        <div className="slide-dv">
          <figure>
            {/* <img className="img-fluid" alt="slid-1" src={thumbnail} /> */}
            <CustomImage thumbnail={thumbnail} />
          </figure>
          <div className="slide-text">
            {/* <p>Lorem Ipsum is simply </p> */}
            <p>{product_name}</p>
            <div className="slide-for-flex">
              {/* <h5>$567.89</h5> */}
              <h5>${unit_price}</h5>
              <div className="slide-star">
                {/* <ul className="slide-star-ul">
                  <li>
                    {" "}
                    <i class="fa fa-star" aria-hidden="true" />
                  </li>
                  <li>
                    {" "}
                    <i class="fa fa-star" aria-hidden="true" />
                  </li>
                  <li>
                    {" "}
                    <i class="fa fa-star" aria-hidden="true" />
                  </li>
                  <li>
                    {" "}
                    <i class="fa fa-star" aria-hidden="true" />
                  </li>
                  <li>
                    {" "}
                    <i class="fa fa-star" aria-hidden="true" />
                  </li>
                </ul> */}
                <Rating
                  allowFraction={true}
                  initialValue={rating && rating}
                  readonly={true}
                  size={20}
                />
              </div>
            </div>
          </div>
        </div>

        </Link>
      </div>
    </>
  );
}

export default Slidecompocard;
